export const roots = [
    {
        link: "/",
        name: "Home"
    },
    {
        link: "/about",
        name: "About Us"
    },
    {
        link: "/services",
        name: "Our Services"
    },
    {
        link: "/career",
        name: "Career"
    },
    {
        link: "/contact",
        name: "Get in Touch"
    }
];

export const services = [
    {
        name: "Transportation"
    },
    {
        name: "Sea Freight"
    },
    {
        name: "Air Freight"
    },
    {
        name: "Rail Freight"
    },
    {
        name: "Customs Clearance"
    }
]